<script lang="ts">
  import { type Business } from '../../lib/types';

  let {
    archivedBusinesses,
    onrestore,
  }: {
    archivedBusinesses: Business[];
    onrestore: (business: Business) => void;
  } = $props();
</script>

{#if archivedBusinesses.length > 0}
  <div class="archived-businesses-card">
    <div class="archived-businesses-header">
      <div class="archived-icon">
        <svg viewBox="0 0 20 20" fill="currentColor">
          <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
          <path fill-rule="evenodd" d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" clip-rule="evenodd" />
        </svg>
      </div>
      <div>
        <h4>Archived Businesses</h4>
        <p class="archived-businesses-subtitle">These businesses have been archived and are hidden from the app.</p>
      </div>
    </div>

    <div class="archived-businesses-list">
      {#each archivedBusinesses as business}
        <div class="archived-business-item">
          <div class="archived-business-avatar">
            {business.name.charAt(0).toUpperCase()}
          </div>
          <div class="archived-business-info">
            <span class="archived-business-name">{business.name}</span>
            {#if business.industry}
              <span class="archived-business-industry">{business.industry}</span>
            {/if}
          </div>
          <button
            class="btn-restore-business"
            onclick={() => onrestore(business)}
          >
            <svg viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
            </svg>
            Restore
          </button>
        </div>
      {/each}
    </div>
  </div>
{/if}

<style>
  .archived-businesses-card {
    background: #fef3c7;
    border: 1px solid #fcd34d;
    border-radius: 8px;
    padding: 1.25rem;
    margin-top: 1rem;
  }

  .archived-businesses-header {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .archived-businesses-header .archived-icon {
    width: 40px;
    height: 40px;
    background: #f59e0b;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .archived-businesses-header .archived-icon svg {
    width: 20px;
    height: 20px;
    color: white;
  }

  .archived-businesses-header h4 {
    margin: 0;
    font-size: 1rem;
    color: #92400e;
  }

  .archived-businesses-subtitle {
    margin: 0.25rem 0 0;
    font-size: 0.85rem;
    color: #a16207;
  }

  .archived-businesses-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .archived-business-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background: white;
    border: 1px solid #fcd34d;
    border-radius: 6px;
    padding: 0.75rem;
  }

  .archived-business-avatar {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #9ca3af;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: 600;
    flex-shrink: 0;
  }

  .archived-business-info {
    flex: 1;
    min-width: 0;
  }

  .archived-business-name {
    display: block;
    font-weight: 500;
    color: #333;
    font-size: 0.95rem;
  }

  .archived-business-industry {
    display: block;
    font-size: 0.8rem;
    color: #666;
  }

  .btn-restore-business {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    background: #059669;
    color: white;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
  }

  .btn-restore-business:hover {
    background: #047857;
    transform: translateY(-1px);
  }

  .btn-restore-business svg {
    width: 16px;
    height: 16px;
  }
</style>
